const setIdentity = (username: string, token: string|boolean) => ({
    type: 'SET_IDENTITY',
    username,
    token
})

export default setIdentity